export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  LIVE_CONTROL: "/live-control",
  INTERCEP_CALIBRATION: "/intercep-calibration",
} as const;
